import { render, staticRenderFns } from "./OnlineTicketsPerDay.vue?vue&type=template&id=2fa5e1d7"
import script from "./OnlineTicketsPerDay.vue?vue&type=script&lang=js"
export * from "./OnlineTicketsPerDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports